import * as React from 'react';
import {List, ListItem, ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
import {Folder} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';

export default function LegalTemplatesTable(): React.ReactElement {
    const {t} = useTranslation();

    return (
        <nav aria-label="main mailbox folders">
            <List>
                <ListItem disablePadding secondaryAction={<ListItemText primary={t('legal.templates.header.lastUpdated')}/>}>
                    <ListItemButton>
                        <ListItemText primary={t('legal.templates.header.name')}/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding secondaryAction={<ListItemText primary="N/A"/>}>
                    <ListItemButton>
                        <ListItemIcon>
                            <Folder/>
                        </ListItemIcon>
                        <ListItemText primary={t('legal.templates.item.legalForms')}/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding secondaryAction={<ListItemText primary="N/A"/>}>
                    <ListItemButton>
                        <ListItemIcon>
                            <Folder/>
                        </ListItemIcon>
                        <ListItemText primary={t('legal.templates.item.nutoFiles')}/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding secondaryAction={<ListItemText primary="N/A"/>}>
                    <ListItemButton>
                        <ListItemIcon>
                            <Folder/>
                        </ListItemIcon>
                        <ListItemText primary={t('legal.templates.item.myConsultations')}/>
                    </ListItemButton>
                </ListItem>
            </List>
        </nav>
    )
}